import LayoutPrimary from '../../layouts/Primary';
import PaletteIndex from '../../views/Admin/Config/Palette/PaletteIndex';
import PaletteEdit from '../../views/Admin/Config/Palette/PaletteEdit';
import PaletteCreate from '../../views/Admin/Config/Palette/PaletteCreate';

export default [
    {
        path: '/palette/create',
        name: 'PaletteCreate',
        component: PaletteCreate,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
    },
    {
        path: '/palette/index',
        name: 'PaletteIndex',
        component: PaletteIndex,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
        props: true,
    },
    {
        path: '/palette/edit/:id',
        name: 'PaletteEdit',
        component: PaletteEdit,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
    },
];
